// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as LookingForTravelerAction } from '../duck';
import LookingForTraveler from '../components/LookingForTraveler';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    isCanceling: state.order.purchase.lookingForTraveler.isCanceling,
    cancelError: state.order.purchase.lookingForTraveler.cancelError,
    cancelSuccessful: state.order.purchase.lookingForTraveler.cancelSuccessful,
    order: state.order.order,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(LookingForTravelerAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LookingForTraveler);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/looking-for-traveler/containers/LookingForTravelerContainer.js